import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import FormFile from "../../components/edit/FormFile";
import FormImage from "../../components/edit/FormImage";
import FormLookup from "../../components/edit/FormLookup";
import FormText from "../../components/edit/FormText";
import FormTextArea from "../../components/edit/FormTextArea";
import FormTiny from "../../components/edit/FormTiny";
import { editCreateColumnType } from "../../editColumnsConfig";
import { getEnumKeyByEnumValue } from "../../enums";
import AdminService from "../../APIService/AdminService";

export default function EditForm<T extends { id: number }>(props: {
  courseOrTask: "course" | "task";
  editItem: T; // TEditCourse | TEditTask
  editColumns: editCreateColumnType[];
  setItem: Dispatch<SetStateAction<T>>;
  readOnly: boolean;
}) {
  const item = props.editItem;
  const attributes = props.editColumns;
  const modDate = item["modDate" as keyof T];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      {attributes.map((field) => {
        if (field.type === "FormText") {
          let [value, setValue] = useState<string>(
            (item[field.name as keyof T] || "") as string,
          );
          const handleChange = (e: any) => {
            setValue(e.target.value);
            //@ts-ignore
            item[field.name as keyof T] =
              e.target.type === "number"
                ? parseInt(e.target.value)
                : e.target.value;
            props.setItem(item);
          };
          // to update readonly fields and other fields we took from db
          useEffect(() => {
            setValue((item[field.name as keyof T] || "") as string);
          });
          return (
            <FormText
              key={field.name}
              title={field.displayName}
              name={field.name}
              id={field.name}
              value={value}
              type={field.formType}
              onChange={handleChange}
              readOnly={field.readonly}
            />
          );
        }

        if (field.type === "FormTextArea") {
          const [value, setValue] = useState(item[field.name as keyof T] || "");
          const handleChange = (e: any) => {
            setValue(e.target.value);
            //@ts-ignore
            item[field.name as keyof T] = e.target.value;
            props.setItem(item);
          };
          return (
            <FormTextArea
              key={field.name}
              title={field.displayName}
              name={field.name}
              id={field.name}
              value={value}
              onChange={handleChange}
              readOnly={field.readonly}
            />
          );
        }

        if (field.type === "FormTiny") {
          const [value, setValue] = useState(item[field.name as keyof T] || "");
          const handleChange = (targetField: string, value: string) => {
            setValue(value);
            //@ts-ignore
            item[field.name as keyof T] = value;
            props.setItem(item);
          };
          return (
            <FormTiny
              key={field.name}
              title={field.displayName}
              onChange={handleChange}
              name={field.name}
              id={field.name}
              value={value}
            />
          );
        }

        if (field.type === "FormLookup") {
          const [value, setValue] = useState(
            getEnumKeyByEnumValue(
              field.lookupEnum,
              (item[field.name as keyof T] as string) || "",
            ),
          );
          const handleChange = (e: any) => {
            setValue(getEnumKeyByEnumValue(field.lookupEnum, e));
            const selectedStr = field.lookupEnum[
              e as keyof typeof field.lookupEnum
            ] as string;
            //@ts-ignore
            item[field.name as keyof T] =
              selectedStr === "NULL"
                ? null
                : (field.lookupEnum[
                    e as keyof typeof field.lookupEnum
                  ] as string) || null;
            props.setItem(item);
          };

          return (
            <FormLookup
              key={field.name}
              onChange={handleChange}
              title={field.displayName}
              enum={field.lookupEnum}
              name={field.name}
              id={field.name}
              value={value}
            />
          );
        }

        if (field.type === "FormImage") {
          // console.dir(item);
          const [value, setValue] = useState(item[field.name as keyof T] || "");

          const uploadImage = (file: ChangeEvent) => {
            const targetFieldId = file.target.id;
            const { files } = file.target as HTMLInputElement;

            const formData = new FormData();
            formData.append("file", files![0]);
            formData.append("field", targetFieldId);
            formData.append("modDate", String(modDate));
            AdminService.uploadFile(
              formData,
              props.courseOrTask,
              targetFieldId,
              item.id!,
            ).then((r) => {
              setValue(r.data);
              //@ts-ignore
              item[field.name as keyof T] = r.data;
              props.setItem(item);
            });
          };

          const onDelete = (): boolean => {
            AdminService.deleteFile(
              props.courseOrTask,
              field.name,
              props.editItem.id,
            );
            setValue("");
            //@ts-ignore
            item[field.name as keyof T] = "";
            props.setItem(item);
            return true;
          };

          return (
            <FormImage
              key={field.name}
              src={value.toString()}
              alt=""
              onChange={uploadImage}
              onDelete={onDelete}
              title={field.displayName}
              name={field.name}
              id={field.name}
              readOnly={props.readOnly}
            />
          );
        }

        if (field.type === "FormFile") {
          const [value, setValue] = useState(item[field.name as keyof T] || "");

          const uploadFile = (file: ChangeEvent) => {
            console.log("uploadFile", file);
            const targetFieldId = file.target.id;
            const { files } = file.target as HTMLInputElement;

            const formData = new FormData();
            formData.append("file", files![0]);
            formData.append("field", targetFieldId);
            AdminService.uploadFile(
              formData,
              props.courseOrTask + "file",
              targetFieldId,
              item.id!,
            ).then((r) => {
              setValue(r.data);
              //@ts-ignore
              item[field.name as keyof T] = r.data;
              props.setItem(item);
            });
          };

          const onDelete = (): boolean => {
            AdminService.deleteFile(
              props.courseOrTask,
              field.name,
              props.editItem.id,
            );
            return true;
          };

          return (
            <FormFile
              key={field.name}
              src={value.toString()}
              alt=""
              onChange={uploadFile}
              onDelete={onDelete}
              title={field.displayName}
              name={field.name}
              id={field.name}
              readOnly={props.readOnly}
            />
          );
        }
      })}
    </div>
  );
}
